import SiteNav from "@/pages/home/components/SiteNav";
import Hero from "@/pages/home/components/Hero";
import VersionOverview from "@/pages/home/components/VersionOverview";
import GlossaryTabs from "@/pages/home/components/GlossaryTabs";
import VersionCompare from "@/pages/home/components/VersionCompare";
import VersionFilter from "@/pages/home/components/VersionFilter";
import Checklist from "@/pages/home/components/Checklist";
import Faq from "@/pages/home/components/Faq";
import SearchIntent from "@/pages/home/components/SearchIntent";
import RelatedTopics from "@/pages/home/components/RelatedTopics";
import SiteFooter from "@/pages/home/components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 font-body text-foreground-950">
      <SiteNav />
      <main>
        <Hero />
        <VersionOverview />
        <GlossaryTabs />
        <VersionCompare />
        <VersionFilter />
        <Checklist />
        <Faq />
        <SearchIntent />
        <RelatedTopics />
      </main>
      <SiteFooter />
    </div>
  );
}